import { getAPI } from 'src/utils/api';
import checkAuthError from '../utils/checkAuthError';

const pingAPI = async () => {
	try {
		const api = await getAPI();
		const { data } = await api.get('/ping');
		return data;
	} catch (error) {
		checkAuthError(error);
		console.error('pingAPI Error', error);
	}
};

export { pingAPI };
